require("core-js/modules/esnext.global-this.js");

!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? n(exports) : "function" == typeof define && define.amd ? define("tailwindcss-classnames", ["exports"], n) : n((e = "undefined" != typeof globalThis ? globalThis : e || self).TailwindcssClassnames = {});
}(this, function (e) {
  "use strict";

  function n(e) {
    var t,
        s,
        f = "";
    if ("string" == typeof e || "number" == typeof e) f += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) {
      e[t] && (s = n(e[t])) && (f && (f += " "), f += s);
    } else for (t in e) {
      e[t] && (f && (f += " "), f += t);
    }
    return f;
  }

  var t = function t() {
    for (var e, t, s = 0, f = ""; s < arguments.length;) {
      (e = arguments[s++]) && (t = n(e)) && (f && (f += " "), f += t);
    }

    return f;
  },
      s = t;

  e.classnames = t, e.default = s, e.tw = s, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});